<template>
  <div class="buyer-details">
    <header-block v-model="show">{{ localizeList.buyerDetails }}</header-block>

    <div class="buyer-details-wrapper" v-if="show">
      <div class="buyer-details-form">
        <form-select
          v-model="selected"
          :items="filteredBuyerTypes"
          :label="localizeList.buyerType"
          select-mode
        />

        <buyer-form
          v-if="showForm"
          v-model="formData"
          :type="selected"
          :citizenships="citizenships"
          :travelers="travelers"
          :user="user"
          @get-countries="getCountries"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { bus } from "@/main.js";
import { Get } from "@/stores/api/methods";
import headerBlock from "../common/headerBlock.vue";
import formSelect from "./fields/buyerSelect.vue";
import buyerForm from "./buyerForm.vue";

export default {
  name: "BuyerDetails",

  props: {
    citizenshipList: {
      type: Array,
      default: () => [],
    },
    trevelerInfo: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      formData: {},
      show: true,
      user: {},
      selected: 2,
      types: [],
    };
  },

  created() {
    bus.$on("isAuthenticated", () => {
      this.getUserInfo();
    });
  },

  async mounted() {
    this.getUserInfo();
    await this.getBuyerTypes();
  },

  methods: {
    getCountries(value) {
      this.$emit('get-countries', value)
    }, 
    async getBuyerTypes() {
      const { data } = await Get(this.$store.getters["getApiUrl"] + "DogovorCustomers");
      this.types = data.map((el) => {
        const { Value, Key } = el;
        return { text: this.localizeList[Key], value: Value, isShow: true };
      });
    },

    getUserInfo() {
      let userInfo = document.cookie
        .split(";")
        .find(x => x.includes("CommonApplicationAuthCookie_.masterweblight-auth"));
      if (!userInfo) return;
      userInfo = userInfo.split("CommonApplicationAuthCookie_.masterweblight-auth=")[1];
      this.user = JSON.parse(userInfo);
      this.selected = 2;

      if (this.hasUser) {
        this.selected = this.user.UserType === 1 ? 2 : 1;
      }
    },
  },

  computed: {
    filteredBuyerTypes() {
      if(!this.hasUser) {
        return this.types.filter(el => el.value === 2)
      }
      
      if(this.user.UserType === 1){
        // Физическое лицо
        return this.types.filter(el => el.value !== 1)
      }

      return this.types
    },

    hasUser() {
      return Object.keys(this.user).length
    },

    citizenships() {
      if (!this.citizenshipList?.length) return [];
      return this.citizenshipList.map((el) => ({
        value: el.Key,
        text: el.Name,
        isShow: true,
      }));
    },

    travelers() {
      if (!this.trevelerInfo?.length) return [];
      return this.trevelerInfo.map((el) => {
        return el.flat().map(({ value, code }) => ({ value, code }));
      });
    },

    showForm() {
      return this.citizenships.length && this.travelers.length;
    },
  },

  watch: {
    formData: {
      handler(val) {
        const data = Object.entries(val).map(el => {
          const [PropertyName, PropertyObject] = el;
          return { PropertyName, Value: PropertyObject.value }
        })

        data.push({ PropertyName: 'Type', Value: this.selected })

        this.$emit("buyerData", data);
      },
      deep: true,
    },
  },

  components: {
    headerBlock,
    formSelect,
    buyerForm,
  },
};
</script>

<style scoped>
.buyer-details {
  background: var(--white-color);
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.11);
  border-radius: 4px;
  margin-bottom: 12px;
  transition: all 0.3s;
}

.buyer-details-wrapper {
  padding: 24px 0px
}

.buyer-details-form {
  padding: 20px 26px 28px;
  max-width: 600px;
  min-height: 500px;
  margin-left: 28px;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.2);
}
</style>
